import { Box, Flex, Text } from '@chakra-ui/react'
import { useContext } from 'react'
import { AiOutlineHistory } from 'react-icons/ai'
import { NavLink } from 'react-router-dom'
import { MLContext } from '../../../../providers'

interface Props {
  versionId: string
  fileId: string
}

const VersionContainer = ({ versionId, fileId }: Props): React.ReactElement => {
  const [{ detailPageVersions }] = useContext(MLContext)
  return (
    <Flex
      as={NavLink}
      to={`/media-library/detail/${fileId}/${versionId}`}
      cursor="pointer"
      background="#F5F7F9"
      border="1px solid #E1E4EB"
      borderRadius="16px"
      height="24px"
      align="center"
      color="#1A202C"
      maxW="105px"
      _hover={{
        border: '1px solid #CDDCF7',
        background: 'appPaleGreyTwo',
        color: 'appBlue',
      }}
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <Box ml="8px">
        <AiOutlineHistory />
      </Box>
      <Box mr="8px">
        <Text ml="8px" fontWeight="500" fontSize="12px">
          {detailPageVersions.find(file => file.versionInfo.id === versionId)
            ?.versionInfo.name ?? versionId}
        </Text>
      </Box>
    </Flex>
  )
}

export default VersionContainer
